import { BuilderConfig } from '../../types/Builder';
import BusinessHubVideoHero, { BusinessHubPlatFormProps } from './business-hub-platform';

export const BusinessHubVideoHeroBuilderConfig = {
    name: 'Business Hub Platform',
    inputs: [
        {
            name: 'backgroundColor',
            type: 'color',
            defaultValue: '',
        },
        {
            name: 'header',
            type: 'html',
            defaultValue: '',
        },
        { name: 'subHeader', type: 'html', defaultValue: '' },
        { name: 'showLearnMore', type: 'boolean', defaultValue: false },
        {
            name: 'cards',
            type: 'list',
            // copyOnAdd: false,
            subFields: [
                {
                    name: 'backgroundColorCard',
                    type: 'color',
                },
                {
                    name: 'logo',
                    type: 'file',
                    defaultValue: '',
                },
                {
                    name: 'title',
                    type: 'html',
                },
                {
                    name: 'description',
                    type: 'html',
                },
                {
                    name: 'linkLearnMore',
                    type: 'string',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<BusinessHubPlatFormProps> = {
    component: BusinessHubVideoHero,
    config: BusinessHubVideoHeroBuilderConfig,
};

export default builderConfig;
